import { LOCALSTORAGE } from "./constants";
import { msalInstance } from "./msalInstance";
import { jwtDecode } from "jwt-decode";
import { decryptData, encryptData } from "./encryption_decryption";
import { setData, setString } from "./storage";

export const getAccessTokenWithRefresh = async (
  scopes: string[],
): Promise<boolean> => {
  const request = {
    scopes,
    account: decryptData(sessionStorage.getItem("AccountDetails") ?? ""),
  };

  const res = await msalInstance
    .acquireTokenSilent(request)
    .then((response) => {
      const decodedToken: any = jwtDecode(response?.idToken);
      const expirationTime = decodedToken?.exp;
      const currentTime = Date.now();
      let expiresIn: any = {
        not_before: currentTime,
        id_token_expires_in: expirationTime,
      };
      setData("expiresIn", expiresIn ,false);

      let access_token = response?.idToken;
      let refresh_token = response?.idToken;

      const refreshtoken: any = encryptData(JSON.stringify(refresh_token));
      setString(LOCALSTORAGE.REFERESH_TOKEN, refresh_token, true);

      const accesstoken: any = encryptData(JSON.stringify(access_token));
      setString(LOCALSTORAGE.ACCESS_TOKEN, access_token, true);

      return true;
    })
    .catch(async (error) => {
      if (error.name === "InteractionRequiredAuthError") {
        await msalInstance
          .acquireTokenPopup(request)
          .then((interactiveResponse) => {
            const refreshtoken: any = encryptData(
              JSON.stringify(interactiveResponse?.idToken),
            );
           setString(LOCALSTORAGE.REFERESH_TOKEN, interactiveResponse?.idToken, true);
            const accesstoken: any = encryptData(
              JSON.stringify(interactiveResponse?.idToken),
            );
            setString(LOCALSTORAGE.ACCESS_TOKEN, interactiveResponse?.idToken, true);
            return true;
          });
      }
      return false;
    });
  return res;
};
